import React from 'react';

const AdminDashboard = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ margin: 0, color: '#1e293b' }}>Admin dashboard in progress.</h2>
    </div>
  );
};

export default AdminDashboard;
